import { jsx } from 'react/jsx-runtime';
import 'react';

const Ai = ()=>{
    return /*#__PURE__*/ jsx("svg", {
        width: "11",
        height: "10",
        viewBox: "0 0 11 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "imageLabel-ai",
        children: /*#__PURE__*/ jsx("path", {
            d: "M0.577383 8L3.01879 0.929688H4.90355L7.34984 8H5.7727L3.99047 2.52637H3.93188L2.14477 8H0.577383ZM5.84105 5.22168V6.36914H2.06664V5.22168H5.84105ZM8.62574 2.69727H10.0711V8H8.62574V2.69727ZM9.3484 1.99902C9.20517 1.99902 9.07333 1.96647 8.95289 1.90137C8.83245 1.83626 8.73642 1.74674 8.6648 1.63281C8.59319 1.51888 8.55738 1.39681 8.55738 1.2666C8.55738 1.13314 8.59319 1.01107 8.6648 0.900391C8.73642 0.786458 8.83245 0.69694 8.95289 0.631836C9.07333 0.566732 9.20517 0.53418 9.3484 0.53418C9.49163 0.53418 9.62346 0.566732 9.74391 0.631836C9.86435 0.69694 9.95875 0.786458 10.0271 0.900391C10.0987 1.01107 10.1345 1.13314 10.1345 1.2666C10.1345 1.39681 10.0987 1.51888 10.0271 1.63281C9.95875 1.74674 9.86435 1.83626 9.74391 1.90137C9.62346 1.96647 9.49163 1.99902 9.3484 1.99902Z",
            fill: "currentColor"
        })
    });
};

export { Ai as default };
